import { accessRole } from "../../../../helpers/access_role";

import React, { Fragment, useState, useRef } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";

import TablePrimaryComponent from "./Components/TablePrimaryComponent";
import TableSecondaryComponent from "./Components/TableSecondaryComponent";

const IndexView = (props) => {
  const [activeTab, setactiveTab] = useState("1");
  const activeRef = useRef();
  const inactiveRef = useRef();
  const secondaryRef = useRef();

  const reloadActiveRef = () => activeRef.current.setTokenAPI();
  const reloadInactiveRef = () => activeRef.current.setTokenAPI();
  const reloadSecondaryRef = () => secondaryRef.current.setTokenAPI();

  function toggle(tab) {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  }

  return (
    <Fragment>
      <Container fluid>
        <Row>
          <Col xs="12">
            <Card className="">
              <CardBody>
                <CardTitle>Daftar Pemberhentian Pegawai</CardTitle>
                <CardSubtitle className="mb-3">
                  Kelola Daftar Pemberhentian Pegawai
                </CardSubtitle>
                <hr />
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === "1",
                      })}
                      onClick={() => {
                        toggle("1");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="fas fa-home"></i>
                      </span>
                      <span className="d-none d-sm-block">
                        Data Rekomendasi
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === "2",
                      })}
                      onClick={() => {
                        toggle("2");
                      }}
                    >
                      <span className="d-block d-sm-none">
                        <i className="far fa-envelope"></i>
                      </span>
                      <span className="d-none d-sm-block">Data Usulan</span>
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab} className="p-3 text-muted">
                  <TabPane tabId="1">
                    <TablePrimaryComponent
                      ref={activeRef}
                      handleProcessSuccess={reloadSecondaryRef}
                      handleInactiveSuccess={reloadInactiveRef}
                    />
                  </TabPane>
                  <TabPane tabId="2">
                    <TableSecondaryComponent
                      ref={secondaryRef}
                      handleInactiveSuccess={reloadInactiveRef}
                    />
                  </TabPane>
                </TabContent>

                <br />
                <div>
                  <Link to="/kepegawaian/pensiun.html">
                    <Button color="danger">
                      <i className="uil-backspace"></i> Kembali
                    </Button>
                  </Link>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default IndexView;
